// Hộp thoại xác nhận dùng chung — thay window.confirm bằng modal căn giữa.
// ModalProvider đăng ký handler thật khi app khởi động; trước đó fallback về window.confirm.
let handler = (message) => Promise.resolve(window.confirm(message));

export function setConfirmHandler(fn) {
  handler = fn || handler;
}

// confirm(message, { title, okText, cancelText, danger }) -> Promise<boolean>
export function confirm(message, opts) {
  return handler(message, opts);
}
